import { useAppSelector } from '@customer/store/hooks';
import { ChartColorScheme } from '../config';
import { getColorScheme } from '../utils';
import styles from './StackedBar.module.scss';

interface PortionStyle {
  width: string;
  backgroundColor: string;
}

interface StackedBarProps {
  total?: number;
  portions: number[];
  colorScheme: ChartColorScheme;
}

export const StackedBar = ({ total, portions, colorScheme }: StackedBarProps) => {
  const { darkTheme } = useAppSelector(state => state.prefs);

  const colors = getColorScheme(colorScheme);

  const percentageData: PortionStyle[] = portions.map((portion: number, i: number) => {
    const themeColors = colors[i % colors.length];
    const backgroundColor = darkTheme ? themeColors[1] : themeColors[0];
    const percentage = total ? (portion / total) * 100 : 0;

    return {
      width: `${percentage}%`,
      backgroundColor,
    };
  });

  const lastColorPair = colors[colors.length - 1];
  const backgroundColor = darkTheme ? lastColorPair[1] : lastColorPair[0];

  return (
    <div className={styles.container}>
      <div
        className={`${styles.bar} ${total && styles['bar--animate-in']}`}
        style={{ backgroundColor }}
      >
        {percentageData.map((portionStyle: PortionStyle, i: number) => (
          <div key={i} className={styles.bar__portion} style={{ ...portionStyle }} />
        ))}
      </div>
    </div>
  );
};

export default StackedBar;
